"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var FileReference = require('../procedure/file-reference');

var attachmentType = require('../../constant/chemical/inventory-attachment-type.constant');

var InventoryAttachment = /*#__PURE__*/function () {
  function InventoryAttachment(opt) {
    _classCallCheck(this, InventoryAttachment);

    this._id = new ObjectId();
    this.inventoryId = null;
    this.familyId = null;
    this.attachment = null;
    this.attachmentType = null;
    this.shareWithInformatics = false;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(InventoryAttachment, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.inventoryId = new ObjectId(opt.inventoryId);
      this.familyId = new ObjectId(opt.familyId);
      this.attachment = new FileReference(opt.attachment);
      this.attachmentType = opt.attachmentType;
      this.shareWithInformatics = !!opt.shareWithInformatics;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, InventoryAttachment.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'inventory-attachment.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          inventoryId: {
            type: 'object'
          },
          familyId: {
            type: 'object'
          },
          attachment: {
            type: {
              $ref: 'file-reference.schema.json'
            }
          },
          attachmentType: {
            type: {
              "enum": Object.values(attachmentType)
            }
          },
          shareWithInformatics: {
            type: 'boolean'
          }
        },
        required: Object.keys(new InventoryAttachment())
      };
    }
  }]);

  return InventoryAttachment;
}();

tv4.addSchema(FileReference.schema());
module.exports = InventoryAttachment;